import { QuestionRepository } from "../../../../data/repository/question/QuestionRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface QuestionGiveAnswerUseCase {
  invoke: (
    questionId: string,
    isCorrect: boolean,
  ) => Promise<ResponseState<Message>>;
}

export class QuestionGiveAnswerUseCaseImpl implements QuestionGiveAnswerUseCase {
  private questionRepository: QuestionRepository;

  constructor(questionRepository: QuestionRepository) {
    this.questionRepository = questionRepository;
  }

  async invoke(
    questionId: string,
    isCorrect: boolean,
  ): Promise<ResponseState<Message>> {
    try {
      let response = await this.questionRepository.giveAnswer(
        questionId,
        isCorrect,
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
